module.exports = __webpack_public_path__ + "img/Importing_1200x800.6629a777.png";